import { IOzonDropoffPoint, IOzonDropoffSearchResponse, ozonDeliveryApi } from 'api/ozonDelivery'
import { fromOzonDropoffPoint, IMapPoint } from './shipmentPoints'

const INFO_BATCH_SIZE = 100
const INFO_CONCURRENCY = 5

export const loadOzonDropoffCatalog = async (): Promise<IMapPoint[]> => {
  const sources = new Map<string, IOzonDropoffPoint>()
  const visitedCursors = new Set<string>()
  let cursor: string | null = null

  while (true) {
    const response = await ozonDeliveryApi.searchDropoffPoints(cursor)
    const data: IOzonDropoffSearchResponse = response.data
    for (const point of data.dropoff_points ?? []) {
      sources.set(String(point.dropoff_point_id), point)
    }
    const next: string | null = data.next_cursor ?? data.pagination?.next_cursor ?? null
    if (!next || visitedCursors.has(next)) break
    visitedCursors.add(next)
    cursor = next
  }

  // Ozon may return short records from search; ask for details only where coordinates are missing.
  const missingIds = Array.from(sources.values())
    .filter((point) => !fromOzonDropoffPoint(point))
    .map((point) => Number(point.dropoff_point_id))
    .filter((id) => Number.isSafeInteger(id) && id > 0)
  const batches: number[][] = []
  for (let start = 0; start < missingIds.length; start += INFO_BATCH_SIZE) {
    batches.push(missingIds.slice(start, start + INFO_BATCH_SIZE))
  }
  for (let start = 0; start < batches.length; start += INFO_CONCURRENCY) {
    const responses = await Promise.all(
      batches.slice(start, start + INFO_CONCURRENCY)
        .map((ids) => ozonDeliveryApi.getDropoffPointsInfo(ids))
    )
    responses.forEach(({ data }) => {
      for (const point of data.dropoff_points ?? []) {
        sources.set(String(point.dropoff_point_id), point)
      }
    })
  }

  return Array.from(sources.values())
    .map(fromOzonDropoffPoint)
    .filter((point): point is IMapPoint => point !== null)
}
